import React from "react";

export const ASSETS = {
    mascot: "https://customer-assets.emergentagent.com/job_cream-time/artifacts/sqiwy9ul_eistroll.png",
    wreath: "https://customer-assets.emergentagent.com/job_cream-time/artifacts/cfksvpfy_website.png",
};

// Decorative leaf SVG element
export const LeafCorner = ({ className = "", flip = false }) => (
    <svg
        viewBox="0 0 200 200"
        className={`pointer-events-none ${className}`}
        style={flip ? { transform: "scaleX(-1)" } : {}}
        aria-hidden="true"
    >
        <g fill="#A8C8A4" opacity="0.7">
            <path d="M20,40 Q60,20 100,50 Q70,60 50,90 Q40,60 20,40 Z" />
            <path d="M30,80 Q70,70 110,100 Q80,115 60,140 Q45,110 30,80 Z" opacity="0.65" />
            <path d="M10,130 Q50,120 90,150 Q60,170 40,190 Q20,160 10,130 Z" opacity="0.5" />
        </g>
        <g fill="#7DA27E" opacity="0.55">
            <ellipse cx="60" cy="35" rx="14" ry="6" transform="rotate(-25 60 35)" />
            <ellipse cx="40" cy="60" rx="12" ry="5" transform="rotate(15 40 60)" />
            <ellipse cx="80" cy="110" rx="14" ry="6" transform="rotate(-30 80 110)" />
        </g>
    </svg>
);

export const FlowerSpot = ({ className = "" }) => (
    <svg viewBox="0 0 60 60" className={`pointer-events-none ${className}`} aria-hidden="true">
        <g>
            {[0, 72, 144, 216, 288].map((rot) => (
                <ellipse
                    key={rot}
                    cx="30" cy="18" rx="6" ry="11"
                    fill="#F4C2C2"
                    transform={`rotate(${rot} 30 30)`}
                />
            ))}
            <circle cx="30" cy="30" r="5" fill="#FCD34D" />
        </g>
    </svg>
);
